

export const translation = {
  en: {
    "moa": "Ministry of Ayush",
    "signOut": "Sign Out",
    "skipToContent": "Skip to Content",
    "aboutIndia": "About India",
    "aboutMoa": "About Ministry of Ayush",
    "globalCollab": " Global Collaborations",
    "statusInIndia":"Status of TM in India",
    "loginRegister": "Login / Register",
    "dashboard": "Dashboard",
    "logout": "LogOut",
    "ayushGlobal": "Ayush Global",
    "resetPwd": "Reset Password"
  },
  ar: {
    "moa": "وزارة أيوش",
    "signOut": "خروج",
    "skipToContent": " تخطى الى المحتوى",
    "aboutIndia": "حول الهند",
    "aboutMoa": "حول وزارة أيوش",
     "statusInIndia":"حالة TM في الهند",
    "globalCollab": " التعاون العالمي",
    "loginRegister": "دخولتسجيل",
    "dashboard": "لوحة القيادة",
    "logout": "تسجيل خروج",
    "ayushGlobal": "أيوش العالمية",
    "resetPwd": "إعادة تعيين كلمة المرور"
  },
  es: {
    "moa": "Ministerio de Ayush",
    "signOut": "Desconectar",
    "skipToContent": " Saltar al contenido",
    "aboutIndia": "Acerca de la India",
    "aboutMoa": "Sobre el ministerio de Ayush",
     "statusInIndia":"Estado de la MT en la India",
    "globalCollab": " Colaboraciones globales",
    "loginRegister": "Iniciar sesión / registrarse",
    "dashboard": "Panel",
    "logout": "Cerrar sesión",
    "ayushGlobal": "Ayush Global",
    "resetPwd": "Restablecer la contraseña"
  },
  ru: {
    "moa": "Министерство Аюша",
    "signOut": "Выход",
    "skipToContent": " Перейти к содержанию",
    "aboutIndia": "Об Индии",
    "aboutMoa": "О служении Аюша",
     "statusInIndia":"Статус ТМ в Индии",
    "globalCollab": " Глобальное сотрудничество",
    "loginRegister": "Войти / регистр",
    "dashboard": "Панель приборов",
    "logout": "Выйти",
    "ayushGlobal": "Ayush Global",
    "resetPwd": "Сброс пароля"
  },
  zh: {
    "moa": "阿尤什部",
    "signOut": "登出",
    "skipToContent": " 跳到内容",
    "aboutIndia": "关于印度",
    "aboutMoa": "关于阿尤什的事工",
     "statusInIndia":"印度 TM 的现状",
    "globalCollab": " 全球合作",
    "loginRegister": "登录 /注册",
    "dashboard": "仪表板",
    "logout": "登出",
    "ayushGlobal": "Ayush Global",
    "resetPwd": "重设密码"
  },
  fr: {
    "moa": "Ministère d  Ayush",
    "signOut": "Se déconnecter",
    "skipToContent": "Aller au contenu",
    "aboutIndia": "À propos del  Inde",
    "aboutMoa": "À propos du ministère d’Ayush",
     "statusInIndia":"Statut de la MT en Inde",
    "globalCollab": "Collaborations mondiales",
    "loginRegister": "S identifier S enregistrer",
    "dashboard": "Tableau de bord",
    "logout": "LogOut",
    "ayushGlobal": "Ayush Global",
    "resetPwd": "réinitialiser le mot de passe"
  }

};